
import { SEARCH_MEMBERS } from '../actions/SearchMembersAction';

const initialState = {
    error: null,
    searchKeyword: ""
}

const SearchMembersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_MEMBERS:
            return {
                ...state,
                searchKeyword: action.data,
            }
        default:
            return {...state};
    }
};

export default SearchMembersReducer;